import { Card, Text } from "@marekl/adminer/components";
import { formatMoney } from "../../lib/money";
import styles from "./TotalsSummary.module.css";
import type { Totals } from "../../lib/queries/documents";

/**
 * The VAT recap and grand total, as the server computed them. A company that
 * is not a VAT payer has no recap: just the total to pay.
 */
export function TotalsSummary({
  totals,
  currency,
  vatPayer,
  pending,
}: {
  totals: Pick<Totals, "vat_totals" | "total_base" | "total_vat" | "total_incl_vat"> | undefined;
  currency: string;
  vatPayer: boolean;
  pending?: boolean;
}) {
  return (
    <Card>
      <Card.Header title="Souhrn" subtitle={pending ? "přepočítává se…" : undefined} />
      <Card.Content>
        {!totals ? (
          <Text variant="muted">Doplňte položky.</Text>
        ) : !vatPayer ? (
          <div className={styles.total}>
            <span>Celkem k úhradě</span>
            <span data-testid="grand-total">
              {formatMoney(totals.total_incl_vat, currency)}
            </span>
          </div>
        ) : (
          <table className={styles.table} aria-label="Rekapitulace DPH">
            <thead>
              <tr>
                <th>Sazba</th>
                <th className={styles.num}>Základ</th>
                <th className={styles.num}>DPH</th>
                <th className={styles.num}>S DPH</th>
              </tr>
            </thead>
            <tbody>
              {totals.vat_totals.map((r) => (
                <tr key={r.vat_rate}>
                  <td>{r.vat_rate} %</td>
                  <td className={styles.num}>{formatMoney(r.base, currency)}</td>
                  <td className={styles.num}>{formatMoney(r.vat, currency)}</td>
                  <td className={styles.num}>{formatMoney(r.incl_vat, currency)}</td>
                </tr>
              ))}
              <tr className={styles.grand}>
                <th colSpan={3}>Celkem k úhradě</th>
                <td className={styles.num} data-testid="grand-total">
                  {formatMoney(totals.total_incl_vat, currency)}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </Card.Content>
    </Card>
  );
}
